<template>
  <v-card class="pa-5" elevation="0" outlined min-width="600" max-width="800">
    <UploadMultipleImages
      :u-i-d="uID"
      @addFile="addFile"
    ></UploadMultipleImages>
    <div v-if="images && images.length > 0">
      <CarouselImages
        :items="images"
        :is-admin="true"
        @deleteImage="deleteImage"
      ></CarouselImages>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(save)">
        <ValidationProvider
          v-slot="{ errors }"
          name="nombre"
          rules="required|min:5"
        >
          <v-text-field
            v-model="proyecto.nombre"
            type="text"
            label="Nombre"
            class="mb-n4"
          ></v-text-field>
          <span class="red--text">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="descripción"
          rules="required|min:5"
        >
          <v-textarea
            v-model="proyecto.descripcion"
            type="text"
            label="Descripcion"
            class="mb-n4"
            rows="2"
          ></v-textarea>
          <span class="red--text">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="tecnologías"
          rules="required|min:3"
        >
          <v-textarea
            v-model="proyecto.tecnologias"
            type="text"
            label="Tecnologías"
            class="mb-n4"
            rows="2"
          ></v-textarea>
          <span class="red--text">{{ errors[0] }}</span>
        </ValidationProvider>

        <v-checkbox
          v-model="proyecto.visible"
          label="Visible para el publico"
        ></v-checkbox>

        <v-btn text small @click="to('proyectos')">
          Regresar
        </v-btn>

        <v-btn color="primary" text small type="submit">
          Guardar
        </v-btn>
      </v-form>
    </ValidationObserver>
    <v-overlay
      :absolute="absolute"
      :opacity="opacity"
      :value="projectCreationPending"
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import UploadMultipleImages from '@/components/admin/project/UploadMultipleImages.vue'
import CarouselImages from '@/components/normal/CarouselImages.vue'

export default {
  name: 'FormularioNuevoProyecto',
  components: {
    UploadMultipleImages,
    ValidationObserver,
    CarouselImages
  },
  props: {},
  data() {
    return {
      absolute: true,
      opacity: 0.5,
      proyecto: {
        nombre: null,
        descripcion: null,
        tecnologias: null,
        visible: false
      },
      defaultProyecto: {
        nombre: null,
        descripcion: null,
        tecnologias: null,
        visible: false
      }
    }
  },
  computed: {
    ...mapState('projectsRoot', ['projectCreationPending', 'project']),
    uID() {
      return this.project.id
    },
    images() {
      return this.project.images
    }
  },
  async beforeMount() {
    await this.getIDProject()
  },
  methods: {
    ...mapMutations('projectsRoot', [
      'setDataProjectToCreate',
      'setImageProjectToCreate'
    ]),
    ...mapActions('projectsRoot', ['triggerAddProjectAction', 'getIDProject']),
    addFile(newFile) {
      this.setImageProjectToCreate(newFile)
    },
    previewImage(event) {
      this.uploadValue = 0
      this.picture = null
      // eslint-disable-next-line prefer-destructuring
      this.imageData = event.target.files[0]
    },
    async deleteImage(image) {
      console.log(
        '🚀 ~ file: ProjectNew.vue ~ line 158 ~ deleteImage ~ image',
        image
      )
    },
    async save() {
      await this.setDataProjectToCreate(this.proyecto)
      await this.triggerAddProjectAction()
      this.proyecto = JSON.parse(JSON.stringify(this.defaultProyecto))
    },
    to(name, params) {
      // console.log('to -> name', name)
      this.$router.push({ name, params })
    }
  }
}
</script>

<style lang="scss" scoped>
img.preview {
  width: 200px;
}
</style>
